import {storage, STORAGE_KEYS} from "./storage";

const togglePrint = (value) => {
    let val = value ? "autoPrint" : null;
    return storage.set(STORAGE_KEYS.autoPrint, val);
}

const getAutoPrint = () => storage.get(STORAGE_KEYS.autoPrint) === "autoPrint";

export {
    togglePrint,
    getAutoPrint
}
